import Vue from "vue";
import VueRouter from "vue-router";
import ShortLink from "../views/shortLink.vue";
import E_ShortLink from "../views/e_shprtLink.vue";
import Auth_bocjs from "../views/auth_bocjs.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: '/:id',
    name: "ShortLink",
    component: ShortLink,
  },
  {
    path: '/e/:code/:id',
    name: "ShortLink",
    component: E_ShortLink,
  },
  {
    path: '/auth/jump2cip',
    name: "AuthBocjs",
    component: Auth_bocjs,
  },
  {
    path: '/auth/bocjs',
    name: "AuthBocjs",
    component: Auth_bocjs,
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: process.env.BASE_URL,
});

export default router;
